import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  status: 'idle',
  error: null,
}
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.data.emailId
      state.token = action.payload.data.token
    },
    logout: (state, action) => {
      state.user = null
      state.token = null
      localStorage.clear()
    },
  },
})

export const { logout, setCredentials } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state) => state.auth.user
export const selectCurrentToken = (state) => state.auth.token